import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

@Injectable()
export class FilesService
{
	// constructor
	constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string)
	{

	}

	// get file types
	public getFileTypes(filter?: [])
	{
		return this.http.post(`${this.baseUrl}api/shared/files/getFileTypes`, { fileTypesFilter: filter });
	}

	// download
	download(fileId: string)
	{
		return this.http.get(`${this.baseUrl}api/shared/files/download?IdFile=${fileId}`, { responseType: 'blob' });
	}

	// delete
	delete(id: string)
	{
		return this.http.delete(`${this.baseUrl}api/shared/files/delete?id=${id}`);
	}

	// update
	update(file)
	{
		return this.http.post(`${this.baseUrl}api/shared/files/update`, file);
	}
}